import clsx from "clsx";
import {
  CHARACTERS_RULES,
  CHARACTERS_RULES_RCS,
  RENAME_FIELDS_EXCELL as columnsRename,
} from "./globals";
import { v4 as uuidv4 } from "uuid";
import * as XLSX from "xlsx";
import { today } from "./dateHelpers";

export const classNames = (...classes) => {
  return clsx(...classes);
};

export const getMessageSettings = (text) => {
  if (!text) {
    return { ...CHARACTERS_RULES.NORMAL, type: "NORMAL" };
  }

  if (CHARACTERS_RULES.SPECIAL.regex.test(text)) {
    return { ...CHARACTERS_RULES.SPECIAL, type: "SPECIAL" };
  }

  if (text.length > 160) {
    return { ...CHARACTERS_RULES.LONG, type: "LONG" };
  }

  return { ...CHARACTERS_RULES.NORMAL, type: "NORMAL" };
};

export const getMessageSettingRCS = (text) => {
  if (!text) {
    return { ...CHARACTERS_RULES_RCS.BASIC, type: "BASIC" };
  }

  if (text.length > 160) {
    return { ...CHARACTERS_RULES_RCS.SINGLE, type: "SINGLE" };
  }

  return { ...CHARACTERS_RULES_RCS.BASIC, type: "BASIC" };
};

export const generateRandomUUID = () => {
  return uuidv4();
};

export const errorLabels = (errors) => {
  const getErrorMessages = (errorObj) => {
    const messages = [];

    Object.keys(errorObj).forEach((key) => {
      const value = errorObj[key];

      if (Array.isArray(value)) {
        value.forEach((item) => {
          if (item && typeof item === "object") {
            const nestedMessages = getErrorMessages(item);
            if (nestedMessages.length > 0) {
              messages.push(...nestedMessages);
            }
          } else if (item) {
            messages.push(item);
          }
        });
      } else if (value && typeof value === "object") {
        const nestedMessages = getErrorMessages(value);
        if (nestedMessages.length > 0) {
          messages.push(...nestedMessages);
        }
      } else if (value) {
        messages.push(value);
      }
    });

    return messages;
  };

  return getErrorMessages(errors).join(", ");
};

export const renameFields = (
  obj,
  map = {
    id_customer: "Cliente",
    partner: "Partner",
    period: {
      dateFrom: "Fecha Desde",
      dateTo: "Fecha Hasta",
    },
  },
) => {
  const result = {};
  for (const key in obj) {
    const value = obj[key];

    if (typeof map[key] === "object") {
      const nested = {};
      for (const subKey in obj[key]) {
        const translated = map[key][subKey] || subKey;
        nested[translated] = obj[key][subKey];
      }
      result[key] = nested;
    } else {
      const newKey = map[key] || key;
      result[newKey] = value;
    }
  }

  return result;
};

export const DataToExcel = (data, fileName = "") => {
  const file_name = fileName
    ? `${fileName}.xlsx`
    : `${today()}_${generateRandomUUID()}.xlsx`;

  const items = renameColumns(data);

  const worksheet = XLSX.utils.json_to_sheet(items);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
  //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
  XLSX.writeFile(workbook, file_name);
};

const renameColumns = (data = []) => {
  if (!data.length) {
    return [];
  }

  return data.map((row) => {
    const renamed = {};

    for (const key in row) {
      const newKey = columnsRename[key] || key;
      renamed[newKey] = row[key];
    }

    return renamed;
  });
};
